import { jsx as _jsx } from "react/jsx-runtime";
import { ConfirmationModal } from "@air/component-confirmation-modal";
export const BoardCollectionCancelAllUploadsModal = (param)=>{
    let { onClose, onCancelUpload } = param;
    return /*#__PURE__*/ _jsx(ConfirmationModal, {
        isOpen: true,
        onDismiss: onClose,
        title: "Cancel upload",
        description: "This will affect any assets that have not been uploaded. Completed uploads will still be in the workspace.",
        ctaPrimaryText: "Cancel Upload",
        id: "cancel-board-collection-upload",
        ctaSecondaryText: "Continue Uploading",
        onConfirm: onCancelUpload,
        isDangerous: true
    });
};
